import isAlpha from 'validator/es/lib/isAlpha';
import isEmpty from 'validator/es/lib/isEmpty';
import isFloat from 'validator/es/lib/isFloat';
import isEmail from 'validator/es/lib/isEmail';
import PhoneNumber from '../phoneNumber';

export default class TwigFormRules {
  static required = (value) => value && !isEmpty(value.trim());

  static float = (value) => isFloat(value, { min: 0 });

  static email = (value) => isEmail(value);

  static alpha = (value) => isAlpha(value);

  static noNumbers = (value) => /^([^0-9]*)$/.test(value);

  static phone = (value) => new PhoneNumber(value).isValid;

  static noDefaultValue = (value) => value !== '0';

  static schedule = (value) => /^[01][0-9]:[0134][05]$/.test(value);
}
